module.exports = __webpack_public_path__ + "static/img/yy6.4ff561b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy6.png
// module id = ajDQ
// module chunks = 1